'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.guid = guid;
function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (oldChar) {
    var rand = Math.random() * 16 | 0;
    var newChar = oldChar === 'x' ? rand : rand & 0x3 | 0x8;
    return newChar.toString(16);
  });
}


//////////////////
// WEBPACK FOOTER
// ../~/bastetjs/lib/utils/guid.js
// module id = 476
// module chunks = 0